/**
 * @fileoverview Helper methods for the Google location autocomplete widget.
 */

/**
 * Generates an empty google item from a label and radius options provided to the component.
 *
 * @param label
 * The label of the item.
 *
 * @param radiusParams
 * The radius parameters passed to the component as props.
 */
export function generateEmptyGoogleItem(label: string, radiusParams?: any) {
  // something in the URL. The backend can try to resolve this location.
  const emptyItem = {
    label,
    radius: (radiusParams?.defaultValue ?? 100) * radiusParams?.unitMultiplier,
    lat: null,
    lon: null,
    country: '',
    administrativeArea: '',
    locationType: '',
  };

  return emptyItem;
}

/**
 * Get a component name from the address from google.
 *
 * @param address
 *  The address component that google returns.
 *
 * @param componentName
 *  The name of the component we want to get.
 *
 * @return {string}
 *  The name of the component (e.g. location)
 */
export const getAddressComponent = (
  address: any,
  componentName: string,
): string => {
  // Get the long name of the address item with the given component name.
  const addressComponentLongNames = address
    .filter((addressItem) => {
      return addressItem.types.includes(componentName);
    })
    .map((addressItem) => {
      return addressItem.long_name;
    });

  if (addressComponentLongNames.length > 0) {
    return addressComponentLongNames[0];
  }
  return '';
};
